import { auditReports } from '@mi-front/api-clients';
import { ComponentType } from 'react';
import { AodRuleWizardCompletedValues } from '../types';
import { useGipAltAodFactory } from './gip-alt/GipAltAodFactory';
import { useGipAodFactory } from './gip/GipAodFactory';

export interface AodRunActionsProps {
  run: auditReports.AodRun;
  display?: 'short' | 'long';
}

export interface AodReportFactory<
  Values extends AodRuleWizardCompletedValues = AodRuleWizardCompletedValues<any, any, any>,
  CreateDto extends auditReports.CreateAodRuleDto = auditReports.CreateAodRuleDto,
  RuleDto extends auditReports.AodRule = auditReports.AodRule,
> {
  fields: {
    ExportConditions?: ComponentType<any>;
  };
  wizardForms: {
    ReportConfig: ComponentType<any>;
    ExportOptions?: ComponentType<any>;
    ExportConditions?: ComponentType<any>;
  };
  views: {
    ReportConfig: ComponentType<{ reportConfig: CreateDto['reportConfig'] }>;
    ExportOptions?: ComponentType<{
      exportOptions: CreateDto['exportOptions'];
    }>;
    ExportConditions?: ComponentType<{
      exportConditions: CreateDto['exportConditions'];
    }>;
    RunDataPreview?: ComponentType<{
      data: Pick<auditReports.AodRun, 'overrideReportConfig'>;
    }>;
    RunActions?: ComponentType<AodRunActionsProps>;
  };
  valuesToApi: (values: Values) => CreateDto;

  // if the values are loading, null will be returned
  apiToValues: (rule: RuleDto) => Values | null;
}

export function useAodFactory(reportType: string): AodReportFactory {
  const results = {
    [auditReports.AodRuleReportTypeEnum.AUDIT_GIP_STATUS]: useGipAodFactory(),
    [auditReports.AodRuleReportTypeEnum.AUDIT_GIP_ALTERNATIVE_REPORT]: useGipAltAodFactory(),
  };

  switch (reportType) {
    case auditReports.AodRuleReportTypeEnum.AUDIT_GIP_STATUS:
      return results[
        auditReports.AodRuleReportTypeEnum.AUDIT_GIP_STATUS
      ] as unknown as AodReportFactory;

    case auditReports.AodRuleReportTypeEnum.AUDIT_GIP_ALTERNATIVE_REPORT:
      return results[
        auditReports.AodRuleReportTypeEnum.AUDIT_GIP_ALTERNATIVE_REPORT
      ] as unknown as AodReportFactory;

    default:
      throw new Error(`Unsupported report type: ${reportType}`);
  }
}
